import {MethodType} from "../utils/request";

const promise = require('../utils/request');

//登录
export const _login = async (params) => {
  return await promise.request('/user/login/shop', MethodType.POST, params)
};

export const _logout = async (params) => {
  return await promise.request('/user/login/out', MethodType.POST, params)
};

//商家开店、关店
export const shopStatusChange = async (params) => {
  return await promise.request('/shop/status/change', MethodType.POST, params)
};

//修改登录密码
export const userPassChange = async (params) => {
  return await promise.request('/user/password/shop/change', MethodType.POST, params)
};
//查询商品分类
export const getCategorieList = async (params) => {
  return await promise.request('/category/list', MethodType.POST, params)
};
//新建编辑删除商品分类
export const getCategorieSave = async (params) => {
  return await promise.request('/category/update', MethodType.POST, params)
};
//获取商品分类详细信息
export const getCategorieInfo = async (params) => {
  return await promise.request('/category/info', MethodType.POST, params)
};
//查询商品
export const getProductList = async (params) => {
  return await promise.request('/product/list/manage', MethodType.POST, params)
};
//商品信息
export const getProductInfo = async (params) => {
  return await promise.request('/product/detail', MethodType.POST, params)
};
//删除商品
export const getProductChangeStatus = async (params) => {
  return await promise.request('/product/status/change', MethodType.POST, params)
};
//订单列表
export const getOrderList = async (params) => {
  return await promise.request('/order/shop/list', MethodType.POST, params)
};
//接单
export const getOrderShopChange = async (params) => {
  return await promise.request('/order/shop/change', MethodType.POST, params)
};
//商家送达
export const getOrderShopArrived = async (params) => {
  return await promise.request('/order/shop/arrived', MethodType.POST, params)
};
//售后详情
export const getOrderAfterSale = async (params) => {
  return await promise.request('/afterSale/info', MethodType.POST, params)
};
//同意售后
export const AgreeAfterSale = async (params) => {
  return await promise.request('/afterSale/shop/agree', MethodType.POST, params)
};
//拒绝售后
export const RefuseAfterSale = async (params) => {
  return await promise.request('/afterSale/shop/refuse', MethodType.POST, params)
};
//订单取消
export const getOrderCancel = async (params) => {
  return await promise.request('/order/cancel', MethodType.POST, params)
};
//财务列表
export const getFinanceListShop = async (params) => {
  return await promise.request('/finance/list/shop', MethodType.POST, params)
};
//商品批量上架
export const getProductOnshelfBatch = async (params) => {
  return await promise.request('/product/onShelf/batch', MethodType.POST, params)
};
//商品批量下架
export const getProductOffshelfBatch = async (params) => {
  return await promise.request('/product/offShelf/batch', MethodType.POST, params)
};
//直接修改商品库存
export const getProductStock = async (params) => {
  return await promise.request('/product/stock', MethodType.POST, params)
};
//批量修改商品库存
export const getProductStockBatch = async (params) => {
  return await promise.request('/product/stock/batch', MethodType.POST, params)
};
//直接修改商品价格
export const getProductPrice = async (params) => {
  return await promise.request('/product/price', MethodType.POST, params)
};
//门店信息相关
export const getShopInfo = async (params) => {
  return await promise.request('/shop/info', MethodType.POST, params)
};

//查看财务打款
export const getShopFinanceList = async (params) => {
  return await promise.request('/finance/history/list/shop', MethodType.POST, params)
};
//查看处罚扣款
export const getShopPunishList = async (params) => {
  return await promise.request('/finance/history/list/punish', MethodType.POST, params)
};
//=========================================================================================================



//查询总店列表
export const getTemplateList = async (params) => {
  return await promise.request('/template/list', MethodType.POST, params)
};
//查询门店列表，用于切换门店
export const getTemplateListShop = async (params) => {
  return await promise.request('/template/list/shop', MethodType.POST, params)
};
//查询总店信息
export const getTemplateInfo = async (params) => {
  return await promise.request('/template/info', MethodType.POST, params)
};
//查询新建或编辑总店弹窗中的店列表
export const getShopListShop = async (params) => {
  return await promise.request('/shop/list/shop', MethodType.POST, params)
};
//新建总店保存
export const getTemplateSave = async (params) => {
  return await promise.request('/template/save', MethodType.POST, params)
};
//删除总店
export const getTemplateChangeStatus = async (params) => {
  return await promise.request('/template/change/status', MethodType.POST, params)
};
//保存分店
export const getTemplateSaveShop = async (params) => {
  return await promise.request('/template/save/shop', MethodType.POST, params)
};
//删除分店
export const getTemplateDeleteShop = async (params) => {
  return await promise.request('/template/delete/shop', MethodType.POST, params)
};
//验证修改总店密码
export const getTemplatePassCheck = async (params) => {
  return await promise.request('/template/pass/check', MethodType.POST, params)
};
//确认修改密码
export const getTemplatePassUpdate = async (params) => {
  return await promise.request('/template/pass/update', MethodType.POST, params)
};
//检查分店
export const getShopCheck = async (params) => {
  return await promise.request('/shop/check', MethodType.POST, params)
};


//上下架商品
export const getProductChangeShelf = async (params) => {
  return await promise.request('/product/change/shelf', MethodType.POST, params)
};
//添加商品
export const getProductSave = async (params) => {
  return await promise.request('/product/save', MethodType.POST, params)
};



//同步商品
export const getProductSync = async (params) => {
  return await promise.request('/product/synchronization', MethodType.POST, params)
};
//删除商品分类
export const getCategorieChangeStatus = async (params) => {
  return await promise.request('/categorie/change/status', MethodType.POST, params)
};

//商品全部同步至分店
export const getProductSyncAll = async (params) => {
  return await promise.request('/product/synchronization/all', MethodType.POST, params)
};
//删除分店下所有商品
export const getProductDelAll = async (params) => {
  return await promise.request('/categorie/eleme/baidu/delete/add', MethodType.POST, params)
};
//直接修改商品及价格
export const getProductChangePriceAndName = async (params) => {
  return await promise.request('/product/change/priceAndName', MethodType.POST, params)
};
//分类排序
export const getCategorieEditSort = async (params) => {
  return await promise.request('/categorie/edit/sort', MethodType.POST, params)
};
//分类信息同步
export const getCategorieSyncAll = async (params) => {
  return await promise.request('/categorie/synchronization/all', MethodType.POST, params)
};
//分类排序同步
export const getCategorieSync = async (params) => {
  return await promise.request('/categorie/synchronization', MethodType.POST, params)
};
//商品排序
export const getProductChangeSort = async (params) => {
  return await promise.request('/product/change/sort', MethodType.POST, params)
};
//拉取
export const getTemplateUpdateShop = async (params) => {
  return await promise.request('/template/update/shop', MethodType.POST, params)
};
//批量改价
export const getProductChangePriceBatch = async (params) => {
  return await promise.request('/product/change/price/batch', MethodType.POST, params)
};
//修改条形码对应的商品图片
export const getProductImageChange = async (params) => {
  return await promise.request('/product/image/change', MethodType.POST, params)
};
//改分类
export const getProductChangeCategory = async (params) => {
  return await promise.request('/product/change/category', MethodType.POST, params)
};
//商品批量添加中待增加的分类处理接口，品类保存后再对于该品类下商品进行增加，最后返回错误Excel
export const getProductMainExcelResave = async (params) => {
  return await promise.request('/product/main/excel/resave', MethodType.POST, params)
};
//商品导出
export const getProductExcelOut = async (params) => {
  return await promise.request('/product/excel/out', MethodType.POST, params)
};
//日志历史记录
export const getHistoryList = async (params) => {
  return await promise.request('/history/list', MethodType.POST, params)
};
//批量改发单价
export const getProductShelfNumberBatch = async (params) => {
  return await promise.request('/product/shelfNumber/batch', MethodType.POST, params)
};

//获取商品原料
export const getMaterialList = async (params) => {
  return await promise.request('/material/list', MethodType.POST, params)
};





//订单同意
export const getOrderAgreere = async (params) => {
  return await promise.request('/order/agreere', MethodType.POST, params)
};
//订单不同意
export const getOrderDisagreere = async (params) => {
  return await promise.request('/order/disagreere', MethodType.POST, params)
};
//订单确认送出
export const getOrderConfirmAlter = async (params) => {
  return await promise.request('/order/confirm/alter', MethodType.POST, params)
};


export const getTemplateUpdateOpentime = async (params) => {
  return await promise.request('/template/update/opentime', MethodType.POST, params)
};
export const getTemplateUpdatePromotion = async (params) => {
  return await promise.request('/template/update/promotion', MethodType.POST, params)
};
export const getTemplateUpdateDescription = async (params) => {
  return await promise.request('/template/update/description', MethodType.POST, params)
};
export const getTemplateUpdateInvoice = async (params) => {
  return await promise.request('/template/update/invoice', MethodType.POST, params)
};
export const getTemplateUpdatePhone = async (params) => {
  return await promise.request('/template/update/phone', MethodType.POST, params)
};
export const getTemplateSynchronization = async (params) => {
  return await promise.request('/template/synchronization', MethodType.POST, params)
};
export const getTemplateSynchronizationPhone = async (params) => {
  return await promise.request('/template/syn/phone', MethodType.POST, params)
};

//活动列表
export const getActivityMainList = async (params) => {
  return await promise.request('/activity/main/list', MethodType.POST, params)
};
//活动详情
export const getActivityMainDetail = async (params) => {
  return await promise.request('/activity/main/detail', MethodType.POST, params)
};
//活动商品
export const getActivityMainProducts = async (params) => {
  return await promise.request('/activity/main/products', MethodType.POST, params)
};
//活动删除
export const getActivityMainDelete = async (params) => {
  return await promise.request('/activity/main/delete', MethodType.POST, params)
};
//活动编辑中选中的店铺
export const getActivityMainShops = async (params) => {
  return await promise.request('/activity/main/shops', MethodType.POST, params)
};
//批量导入商品
export const getActivityBarcodeProductList = async (params) => {
  return await promise.request('/activity/barCode/product/list', MethodType.POST, params)
};
//提交商品
export const getActivityMainAdd = async (params) => {
  return await promise.request('/activity/main/add', MethodType.POST, params)
};
//获取添加活动的商品
export const getActivityMainProductList = async (params) => {
  return await promise.request('/activity/main/product/list', MethodType.POST, params)
};
//总店添加活动商品并且同步到平台
export const getActivityMainProductSave = async (params) => {
  return await promise.request('/activity/main/product/save', MethodType.POST, params)
};

export const getShopUpdateLogo = async (params) => {
  return await promise.request('/shop/update/logo', MethodType.POST, params)
};
export const getShopUpdateName = async (params) => {
  return await promise.request('/shop/update/name', MethodType.POST, params)
};
export const getShopUpdatePhone = async (params) => {
  return await promise.request('/shop/update/phone', MethodType.POST, params)
};
export const getShopUpdateAddress = async (params) => {
  return await promise.request('/shop/update/address', MethodType.POST, params)
};
export const getShopUpdateOpentime = async (params) => {
  return await promise.request('/shop/update/opentime', MethodType.POST, params)
};
export const getShopUpdatePromotion = async (params) => {
  return await promise.request('/shop/update/promotion', MethodType.POST, params)
};
export const getShopUpdateDescription = async (params) => {
  return await promise.request('/shop/update/description', MethodType.POST, params)
};
export const getShopUpdateInvoice = async (params) => {
  return await promise.request('/shop/update/invoice', MethodType.POST, params)
};
//门店招牌信息
export const getRemodelPlateInfo = async (params) => {
  return await promise.request('/remodel/plate/info', MethodType.POST, params)
};
//橱窗装修信息
export const getRemodelWindowInfo = async (params) => {
  return await promise.request('/remodel/window/info', MethodType.POST, params)
};
//橱窗装修保存
export const getRemodelWindowSave = async (params) => {
  return await promise.request('/remodel/window/save', MethodType.POST, params)
};
//商品信息分类
export const getProductQueryProducts = async (params) => {
  return await promise.request('/product/queryProducts', MethodType.POST, params)
};
//分类信息详情
export const getRemodelCategoryInfo = async (params) => {
  return await promise.request('/remodel/category/info', MethodType.POST, params)
};
//分类信息保存
export const getRemodelCategorySave = async (params) => {
  return await promise.request('/remodel/category/save', MethodType.POST, params)
};
//招牌更换
export const getRemodelPlateSave = async (params) => {
  return await promise.request('/remodel/plate/save', MethodType.POST, params)
};
//获取海报
export const getRemodelPostSearch = async (params) => {
  return await promise.request('/remodel/post/search', MethodType.POST, params)
};
//海报信息查询
export const getRemodelPostSearchDetail = async (params) => {
  return await promise.request('/remodel/post/search/detail', MethodType.POST, params)
};
//海报信息保存
export const getRemodelPostSave = async (params) => {
  return await promise.request('/remodel/post/save', MethodType.POST, params)
};
//海报信息废弃
export const getRemodelPostDelete = async (params) => {
  return await promise.request('/remodel/post/delete', MethodType.POST, params)
};
//保存门店信息
export const getShopUpdateDeliver = async (params) => {
  return await promise.request('/shop/update/deliver', MethodType.POST, params)
};

//门店装修同步
export const getRemodelMainPlateSyn = async (params) => {
  return await promise.request('/remodel/main/plate/syn', MethodType.POST, params)
};
export const getRemodelMainPostSyn = async (params) => {
  return await promise.request('/remodel/main/post/syn', MethodType.POST, params)
};
export const getRemodelMainWindowSyn = async (params) => {
  return await promise.request('/remodel/main/window/syn', MethodType.POST, params)
};
export const getRemodelMainCategorySyn = async (params) => {
  return await promise.request('/remodel/main/category/syn', MethodType.POST, params)
};

//查询回收站商品
export const getProductRecycleList = async (params) => {
  return await promise.request('/product/recycle/list', MethodType.POST, params)
};
//删除回收站商品
export const getProductRecycleDelete = async (params) => {
  return await promise.request('/product/recycle/delete', MethodType.POST, params)
};
//恢复回收站商品
export const getProductRecycleRecovery = async (params) => {
  return await promise.request('/product/recycle/recovery', MethodType.POST, params)
};
//回收站商品信息
export const getProductRecycleInfo = async (params) => {
  return await promise.request('/product/recycle/info', MethodType.POST, params)
};
//回收站保存商品
export const getProductRecycleSave = async (params) => {
  return await promise.request('/product/recycle/save', MethodType.POST, params)
};

//excel改价后同步商品价格
export const getProductSyncPriceBatch = async (params) => {
  return await promise.request('/product/syn/price/batch', MethodType.POST, params)
};

//批量删除商品
export const getProductDeleteBatch = async (params) => {
  return await promise.request('/product/delete/batch', MethodType.POST, params)
};

//获取token
export const getToken = () => {
  return
}
//推荐
export const getRecommend = async (params) => {
  return await promise.request('/product/recommend/add', MethodType.POST, params)
};
//取消推荐
export const noRecommend = async (params) => {
  return await promise.request('/product/recommend/cancel', MethodType.POST, params)
};




// WEBPACK FOOTER //
// ./src/constants/api.js